import { useQuery, useQueryClient } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type GetIglooStaffConnectionRequest = { userId: string }

type IglooStaffConnection = { connected: boolean }

export const getIglooStaffConnectionQueryKey = (data: GetIglooStaffConnectionRequest) => [
  'useGetIglooStaffConnection',
  data,
]

const getIglooStaffConnection = async (
  data: GetIglooStaffConnectionRequest,
): Promise<IglooStaffConnection> => {
  const response = await authAPI.get<IglooStaffConnection>(
    `/igloowork/staff/${data.userId}/connection`,
  )
  return { connected: response.data?.connected === true }
}

export const useGetIglooStaffConnection = (data: GetIglooStaffConnectionRequest, enabled = true) =>
  useQuery({
    enabled: enabled && Boolean(data.userId),
    queryFn: () => getIglooStaffConnection(data),
    queryKey: getIglooStaffConnectionQueryKey(data),
  })

export const useInvalidateIglooStaffConnection = (userId: string) => {
  const queryClient = useQueryClient()
  return () =>
    queryClient.invalidateQueries({ queryKey: getIglooStaffConnectionQueryKey({ userId }) })
}
